import { createApp } from 'vue'
import App from './App.vue'
import router from './router'

/* --- CONFIGURACIÓN FONT AWESOME 5 --- */
import { library } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import '@fortawesome/fontawesome-free/css/all.css'

// Los íconos de la v5 se importan igual, pero vienen del paquete 5.15.4 que instalamos
import { 
  faHammer, 
  faHardHat,    
  faSolarPanel, 
  faServer,  
  faPalette,
  faSitemap,
  faEye,
  faHandshake,
  faCoins,
  faShieldAlt
} from '@fortawesome/free-solid-svg-icons'

// Añadirlos a la librería
library.add(
  faHammer, 
  faHardHat, 
  faSolarPanel, 
  faServer,  
  faPalette,
  faSitemap,
  faEye,
  faHandshake,
  faCoins,
  faShieldAlt
)

createApp(App)
  .use(router)
  .component('font-awesome-icon', FontAwesomeIcon)
  .mount('#app')
